import { FcpBadgeListConfig } from '../fcp-badge-list';

export const defaultBadgeListConfig: FcpBadgeListConfig = {
    inversed: false,
    position: 'start',
    tooltip: {
        enabled: false,
        maxWidth: '304px'
    }
};
